"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBatonBaseUrl = exports.getAuthorizationHeader = exports.getClientInstance = void 0;
const axios_1 = __importDefault(require("axios"));
const consts_1 = require("./consts");
const baton_1 = require("./models/baton");
const getClientInstance = (options) => {
    var _a, _b, _c, _d, _e, _f;
    const client = axios_1.default.create();
    (_c = (_b = (_a = options === null || options === void 0 ? void 0 : options.axiosOptions) === null || _a === void 0 ? void 0 : _a.interceptors) === null || _b === void 0 ? void 0 : _b.request) === null || _c === void 0 ? void 0 : _c.forEach(([onFulfilled, onRejected]) => client.interceptors.request.use(onFulfilled, onRejected));
    (_f = (_e = (_d = options === null || options === void 0 ? void 0 : options.axiosOptions) === null || _d === void 0 ? void 0 : _d.interceptors) === null || _e === void 0 ? void 0 : _e.response) === null || _f === void 0 ? void 0 : _f.forEach(([onFulfilled, onRejected]) => client.interceptors.response.use(onFulfilled, onRejected));
    return client;
};
exports.getClientInstance = getClientInstance;
const getAuthorizationHeader = (accessToken) => {
    return {
        Authorization: "Bearer " + accessToken
    };
};
exports.getAuthorizationHeader = getAuthorizationHeader;
const getBatonBaseUrl = (env) => {
    switch (env) {
        case baton_1.BatonEnv.INTEGRATION:
            return consts_1.batonIntBaseUrl;
        case baton_1.BatonEnv.PRODUCTION:
            return consts_1.batonProdBaseUrl;
        default:
            throw new Error(`Invalid Baton environment: ${env}`);
    }
};
exports.getBatonBaseUrl = getBatonBaseUrl;
